<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">查询产销差</div>
    </div>
    <el-form ref="dataForm" class="searchForm" :model="dataForm">
      <el-form-item>
        <el-date-picker
          v-model="dataForm.startDate"
          type="date"
          class="fullList"
          placeholder="请选择开始时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
        <el-date-picker
          v-model="dataForm.endDate"
          type="date"
          class="fullList"
          placeholder="请选择结束时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
        <el-button type="primary" class="fullList" @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      height="calc(100vh - 50px - 240px)"
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        align="center"
        header-align="center"
        label="录入时间"
      />
      <el-table-column
        prop="name"
        align="center"
        header-align="center"
        label="正流量行度"
      />
      <el-table-column
        prop="address"
        align="center"
        header-align="center"
        label="负流量行度"
      />
      <el-table-column
        prop="address"
        align="center"
        header-align="center"
        label="产销差"
      />
    </el-table>
    <el-dialog
      :visible.sync="visible"
      class="msgDialog"
      title="录入数据"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="dataRules"
      >
        <el-form-item label="流量计：" prop="station">
          <el-select v-model="form.station" placeholder="请选择流量计">
            <el-option
              v-for="item in stationOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间：" prop="startDate">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="结束时间：" prop="endDate">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="正流量行度：" prop="openWater">
          <el-input v-model="form.openWater" placeholder="请输入正流量行度" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dataFormSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: true,
      dataForm: {
        station: null,
        stationName: null,
        startDate: null,
        endDate: null
      },
      form: {
        station: null,
        stationName: null,
        startDate: null,
        endDate: null,
        openWater: null,
        endWater: null,
      },
      dataRules: {
        station: [{ required: true, message: '请选择流量计', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
        endDate: [{ required: true, message: '请选择结束日期', trigger: 'blur' }],
        openWater: [{ required: true, message: '请输入正流量行度', trigger: 'blur' }],
      },
      stationOptions: [
        { id: 1, name: "西江（低压）" },
        { id: 2, name: "西江（高压）" },
        { id: 3, name: "水源1" },
        { id: 4, name: "水源2" },
        { id: 5, name: "丹横" },
        { id: 6, name: "建沙" },
        { id: 7, name: "青岐" },
        { id: 8, name: "排灌站" },
        { id: 9, name: "银汇华庭" },
        { id: 10, name: "三水二桥南侧" },
        { id: 11, name: "南江1" },
        { id: 12, name: "南江2" },
        { id: 13, name: "南庄季华路" },
        { id: 14, name: "加压泵站禅城表头" },
        { id: 15, name: "西樵" },
        { id: 16, name: "紫南村总水表" },
        { id: 17, name: "加压泵站入水" },
        { id: 18, name: "加压泵站丹灶表头" },
        { id: 19, name: "东门DN50" },
      ],
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  mounted () {
    this.getQuery()
  },
  activated () {
    // 创建工单后跳转过来后，再返回创建工单再过来就会刷新
    // this.getQuery()
  },
  methods: {
    // 获取选中的地址信息
    getStation(val) {
      this.stationOptions.forEach(item => {
        if (item.id === val) {
          this.dataForm.stationName = item.name
        }
      })
    },
    // 后面获取数据列表
    async getDataList() {
      this.dataListLoading = true;
      this.dataList = [];
      this.dataListLoading = false;
    },
    // 获取到传过来的参数
    async getQuery () {
      this.dataList = []
      // 根据获取的数据请求符合条件的工单
      // await this.$http.httpGet('/app/apptborder/list', query).then(res => {
      //   this.loading = false
      //   if (res.code === 0 && res.msg === 'success') {
      //     this.orderData = res.data
      //   } else {
      //     this.$message.error('获取数据失败: ' + res.msg)
      //   }
      // })
    },
    // 提交表单参数
    dataFormSubmit() {

      this.$http.httpPost('/app/apptborder/updateOrderStatus', {
        "orderId": this.orderDetails.id,
        "status": 7
      }).then(res => {
        if (res.msg === 'success' && res.code === 0) {
          this.$message.success('工单状态改变为作废成功!')
          this.refresh()
        } else {
          this.$message.error('状态更改失败! ' + res.msg)
        }
      })
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }
  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }
}
.msgDialog {
  .el-dialog {
    width: 95%;
    margin: 10vh auto !important;
    height: 80vh;
    .el-dialog__header {
      padding: 10px;
      border-bottom: 1px #efefef solid;
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__footer {
      padding: 10px;
      border-top: 1px #efefef solid;
    }
    .el-dialog__body {
      height: calc(80vh - 166px);
      overflow-x: hidden;
      overflow-y: auto;
      .el-form {
        position: relative;
        .el-form-item {
          margin: 0 0 15px;
          width: 100%;
          position: relative;
          .el-form-item__label {
            width: 100px;
            font-size: 12px;
            padding: 0 5px 0 0;
          }
          .el-form-item__content {
            width: calc(100% - 100px);
            float: right;
            .el-select,.el-input {
              width: 100%;
            }
            .el-form-item__error {
              padding-top: 1px;
            }
          }
        }
      }
    }
  }
}
</style>
